require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-code-501-programming-with-java.json") })
        }
      }, "path---courses-code-501-programming-with-java");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-code-501-programming-with-java!./.cache/json/courses-code-501-programming-with-java.json
// module id = 1154
// module chunks = 231608221292675